import { lighten } from "polished";
import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";
import { AiFillCaretRight } from "react-icons/ai";

type StyledProps = {
  open?: boolean;
};

export const Title = styled.p<StyledProps>`
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-align: left;
  text-transform: uppercase;
  margin-bottom: 10px;  

  @media (max-width: ${defaultBreakpoints.medium}) {
    margin: 0;  
    background-color: ${({ theme, open }) =>
      open ? theme.default.color.primary : "#f7f7f7"};
        transition: background-color 0.4s ease;
    padding: 10px;
    color: ${({ open }) => open && "white"};
  }
`;

export const SectionChildren = styled.div`
  @media (max-width: ${defaultBreakpoints.medium}) {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    background: #f7f7f7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin: 5px;
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px;

    left: 0;
    right: 0;
  }
`;

export const Arrow = styled(AiFillCaretRight)<StyledProps>`
  transform: ${(props) => props.open && "rotate(90deg)"};
  transition: transform 0.4s ease;
  margin: auto 0px auto auto;
  font-size: 1.2rem;

  cursor: pointer;
  @media (min-width: ${defaultBreakpoints.medium}) {
    display: none;
  }
`;
